import { render, staticRenderFns } from "./BasePagesWrapper.vue?vue&type=template&id=e483c3ac&"
import script from "./BasePagesWrapper.vue?vue&type=script&lang=js&"
export * from "./BasePagesWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports